// Parse a Swedish personnummer and derive birth date, age, and gender.
// Accepts 10- and 12-digit formats with optional separators. A '+' separator
// in the 10-digit form means the holder has turned 100 this year or earlier
// and shifts the century back by 100.
// Returns { birthDate: Date, age: number, gender: "Man" | "Kvinna" } or null.
export function parseSsn(raw, today = new Date()) {
  if (!raw) return null;
  const input = String(raw).trim();
  if (!input) return null;

  const usesPlus = input.includes("+");
  const digits = input.replace(/\D/g, "");
  if (digits.length !== 10 && digits.length !== 12) return null;

  let year, month, day;
  if (digits.length === 12) {
    year = parseInt(digits.slice(0, 4), 10);
    month = parseInt(digits.slice(4, 6), 10);
    day = parseInt(digits.slice(6, 8), 10);
  } else {
    const yy = parseInt(digits.slice(0, 2), 10);
    month = parseInt(digits.slice(2, 4), 10);
    day = parseInt(digits.slice(4, 6), 10);

    const currentYear = today.getFullYear();
    const century = Math.floor(currentYear / 100) * 100;
    year = century + yy > currentYear ? century + yy - 100 : century + yy;
    if (usesPlus) year -= 100;
  }

  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  const genderDigit = parseInt(digits.charAt(digits.length - 2), 10);
  const gender = genderDigit % 2 === 0 ? "Kvinna" : "Man";

  const birthDate = new Date(year, month - 1, day);
  let age = today.getFullYear() - year;
  const beforeBirthday =
    today.getMonth() + 1 < month ||
    (today.getMonth() + 1 === month && today.getDate() < day);
  if (beforeBirthday) age--;
  if (age < 0) return null;

  return { birthDate, age, gender };
}

// Formats a raw SSN to YYYYMMDD-XXXX or YYMMDD-XXXX. Returns raw input if unrecognized.
export function formatSsn(raw) {
  if (!raw) return raw;
  const digits = String(raw).replace(/\D/g, "");
  if (digits.length === 12) {
    return `${digits.slice(0, 8)}-${digits.slice(8)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  }
  return raw;
}
